module.exports = __webpack_public_path__ + "static/media/기업인증.22d8822d.png";